import { Component, OnInit } from '@angular/core';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';
import { TipoConsultaEnum } from 'src/app/shared/enums/tipo-consulta-enum.enum';

@Component({
  selector: 'generacion-obras',
  templateUrl: './generacion-obras.component.html',
  styleUrls: ['./generacion-obras.component.scss']
})
export class GeneracionObrasComponent implements OnInit {
  
  public tipoObra: string = '-1';
  public tipoConsulta: string = '';
  
  constructor(
    private facadeSesionService:FacadeSesionService
  ) {
  } 

  ngOnInit() {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad('Generar obra');
    this.facadeSesionService.usuarioEnSesionService.obtenerKeyTipoObra().then(
      (tipoConsulta: string) => this.tipoConsulta = tipoConsulta
    )
  }

  public filtrarPorTipoObra(tipoConsulta: string, keyCatTipoObra: string): boolean {
    if (tipoConsulta === TipoConsultaEnum.ADMINISTRACION) {
      return true;
    }
    if (tipoConsulta === TipoConsultaEnum.PROCESO) {
      return keyCatTipoObra === tipoConsulta ? true : false;
    }
    if (tipoConsulta === TipoConsultaEnum.PLANEACION) {
      return keyCatTipoObra === tipoConsulta ? true : false;
    }

  }

}
